import { useEffect, useMemo, useState } from "react";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import useNavigateNewPerson from "../reports/useNavigateNewPerson";
import PageHeader from "../shared-components/PageHeader";
import TabsSelection, { TabProps } from "../shared-components/TabsSelection";

import { CanAddReportButton } from "./admin-completed/AddNewReport";
import {
  Outlet,
  useLocation,
  useSearchParams,
  Location,
  useNavigate,
} from "react-router-dom";
import ControlGroupWrapper from "../shared-components/ControlGroupWrapper";

const Admin = () => {
  const location: Location = useLocation();

  const [, setParams] = useSearchParams();
  const navigate = useNavigate();
  const { navigateCreatePerson } = useNavigateNewPerson();
  const { canAddReport, legacy } = usePermissionValidator();
  const [initialTab, setInitialTab] = useState("completed");
  const inLegacyUsers: boolean = initialTab === "legacy/users";
  function handleTabSelection() {
    setParams({});
  }

  const tabs: TabProps[] = useMemo(() => {
    const baseTabs: TabProps[] = [
      {
        label: "Operation View",
        identifier: "operation",
        href: "/admin/operation",
      },
      {
        label: "Completed Report",
        identifier: "completed",
        href: "/admin/completed",
      },
    ];
    if (legacy?.canGetUsers) {
      baseTabs.push({
        label: "Legacy Users",
        identifier: "legacy/users",
        href: "/admin/legacy/users",
      });
    }
    return baseTabs;
  }, [legacy]);

  useEffect(() => {
    switch (location.pathname) {
      case "/admin/operation":
        setInitialTab("operation");
        break;
      case "/admin/completed":
        setInitialTab("completed");
        break;
      case "/admin/legacy/users":
        setInitialTab("legacy/users");
        break;
      default:
        setInitialTab("completed");
        navigate("/admin/completed");
        break;
    }
  }, [location, navigate, legacy]);

  return (
    <>
      <ControlGroupWrapper>
        <PageHeader title={"Admin View"}>
          <CanAddReportButton
            canAddReport={canAddReport && !inLegacyUsers}
            navigateCreatePerson={navigateCreatePerson}
          />
        </PageHeader>
        <div className="mb-3">
          <TabsSelection
            tabs={tabs}
            initial={initialTab}
            onChange={handleTabSelection}
          ></TabsSelection>
        </div>
        <div className="pt-4 relative">
          <Outlet></Outlet>
        </div>
      </ControlGroupWrapper>
    </>
  );
};

export default Admin;
